import $ from '../lib/jquery';

import { Component } from '../core/component';

export class NewsletterForm extends Component {
    selector = '.js-newsletter-form';

    $errorMessage = null;

    init() {
        this.$errorMessage = $('.js-newsletter-form-error');

        this.$elements.each((index, element) => {
            const $form = $(element);

            $form.find('.js-newsletter-checkboxes').on('change', this.hideFormErrorMessage);

            $form.on('submit', async (evt) => {
                const form = evt.currentTarget;
                evt.preventDefault();

                // custom FormData cause of the newsletter checkboxes
                const $fd = new FormData(form);

                const selectedCheckboxes = $(form).find('.js-newsletter-checkboxes:checked').toArray();
                if (selectedCheckboxes.length) {
                    $fd.set('audiences', this.formatIds(selectedCheckboxes));
                } else {
                    return this.showFormErrorMessage();
                }

                fetch('/mailchimp/send', {
                    method: 'post',
                    body: $fd,
                })
                    .then(() => {
                        window.location.href = form.redirect.value;
                    });
            });
        });
    }

    showFormErrorMessage = () => {
        this.$errorMessage.addClass('is-visible');
    };

    hideFormErrorMessage = () => {
        this.$errorMessage.removeClass('is-visible');
    };

    showSubscribeErrorMessage = () => {
        // eslint-disable-next-line no-alert
        window.alert('There was a problem submitting that email');
    };

    formatIds(checkboxes) {
        return checkboxes
            .map(checkbox => checkbox.value)
            .join('|');
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/NewsletterForm.js